// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "aabc8d6f710f95584975" + "/js/" + chunkId + ".js";
};